module.exports = __webpack_public_path__ + "img/aruba.a7f3506f.png";